import type { UspBlock } from '~~/types/cms/UspBlock';

export type UspFeatureToggles = {
  isExtraGuaranteeEnabled: boolean,
};

type UspVisibilityRule = (featureToggles: UspFeatureToggles) => boolean;

const USP_VISIBILITY_RULES: Partial<Record<string, UspVisibilityRule>> = {
  'premium-guarantee': featureToggles => featureToggles.isExtraGuaranteeEnabled,
};

export const filterUspBlocks = (
  blocks: Readonly<UspBlock[]>, featureToggles: UspFeatureToggles,
): UspBlock[] => {

  return blocks.filter(block => {

    const visibilityRule = USP_VISIBILITY_RULES[block.key];

    return visibilityRule ? visibilityRule(featureToggles) : true;

  });

};
